import { BaseResourceModel } from '../../models/base-resource.model';
import { Cidade } from '../geo/cidade.model';

export class PostoAbastecimento extends BaseResourceModel {
  constructor(
    public id?: number,
    public nome?: string,
    public cidade?: Cidade,
  ) {
    super();
  }
  static converteJson(json: any): PostoAbastecimento {
    return Object.assign(new PostoAbastecimento(), json);
  }
}
